import { eTipoPermissao } from '@/enums/ePermissoes';

/*
 * REGISTROS DE HIGIENE — a tela da ESCOLA (trocas de fralda e evacuações).
 *
 * A permissão é a de LANÇAMENTO (300100800), diferente da que libera a seção no portal
 * (300100801): quem registra é a professora do berçário, quem lê é o responsável. Ver
 * CLAUDE.md, "Permissão de tela nova".
 */
export default [
  {
    description: 'Registros de Higiene',
    path: '/academico/higiene',
    name: 'registros-higiene',
    component: () => import('@/views/academico/higiene/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.REGISTROSDEHIGIENE_MENU_300100800],
    },
    goesToMenu: true,
  },
];
